import React from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  wrapperClassName?: string;
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({
  value,
  onChange,
  placeholder = 'DD/MM/YYYY HH:mm',
  className = '',
  wrapperClassName = '!w-full !max-w-[255px] block',
}) => {
  const parseToDate = (): Date | null => {
    const [datePart = '', timePart = '00:00'] = value.split(' ');
    const [dd, mm, yyyy] = datePart.split('/');
    if (!dd || !mm || !yyyy) return null;
    const d = dayjs(`${yyyy}-${mm}-${dd}T${timePart}`);
    return d.isValid() ? d.toDate() : null;
  };

  const handleChange = (date: Date | null) => {
    if (!date) return;
    onChange(dayjs(date).format('DD/MM/YYYY HH:mm'));
  };

  return (
    <DatePicker
      selected={parseToDate()}
      onChange={handleChange}
      dateFormat="dd/MM/yyyy HH:mm"
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={15}
      placeholderText={placeholder}
      wrapperClassName={wrapperClassName}
      className={`border border-[#fec733] dark:border-[#808080] rounded px-2 text-[12px] !w-full h-[30px] bg-white dark:bg-transparent dark:text-white outline-none cursor-pointer ${className}`}
      calendarClassName="!bg-white !border !border-gray-200 !shadow-lg"
      popperPlacement="bottom-start"
    />
  );
};

export default DatePickerInput;
